export default __webpack_public_path__ + "static/simple-column-d2d0b4124914a43c0e3baea1607d74e8.png";